module.exports = __webpack_public_path__ + "static/media/23 - Steve Lacy - Dark Red.08d60513.mp3";